import {calcUserScore, filterObjectByParams} from 'helpers/common-helper';
import BasePlayer from 'services/sports/default/base-player';
import {getDefaultExposure} from 'helpers/player-helper';
import {SearchRuleBuilder as RuleBuilder} from 'services/search-rule-builder';
import {getPlayerProjOwnFunctionality} from 'helpers/projected-ownership';

export default class Player extends BasePlayer {
    getExpandedEntityParams({incomingValues = {}}) {
        const {userPointsType = 'adminPoints'} = incomingValues;
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});
        const userPoints = parseFloat(expandedPlayer[userPointsType]);

        return {
            ...expandedPlayer,
            userPoints,
            userScore: calcUserScore(userPoints, expandedPlayer.salary, this.userScoreMultiplier),
            grades: parseFloat(expandedPlayer.grades * 1),
            projOwn: {...getPlayerProjOwnFunctionality(expandedPlayer)},
            resetExposure() {
                this.exposureMin = getDefaultExposure('min');
                this.exposureMax = getDefaultExposure('max');
            },
        };
    }

    preparePoolsOfPlayers({incomingValues: {players, filterPlayersBeforePreparingPools}}) {
        if (!filterPlayersBeforePreparingPools) {
            return this.exec('createPoolsOfPlayers', {
                players: Object.values(players),
            });
        }

        const params = {
            ...RuleBuilder.callback('playerId', function (player) {
                return !player.isExcludedAnywhere();
            }),
        };

        players = filterObjectByParams(players, params, true);

        return this.exec('createPoolsOfPlayers', {
            players,
        });
    }
}
